import Layout from '../../../Components/Layout/Layout';
import { Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CgProfile } from 'react-icons/cg';
import { BiLogOutCircle } from 'react-icons/bi';
import { RiKeyLine } from 'react-icons/ri';
import { BsFillSdCardFill } from 'react-icons/bs';
import { FaFileInvoice } from 'react-icons/fa';
import { RiWechatLine } from 'react-icons/ri';
import { ImLocation } from 'react-icons/im';
import { BiUserCheck } from 'react-icons/bi';
import { CgProductHunt } from 'react-icons/cg';
import { HiPhone } from 'react-icons/hi';
import { HiOutlineMailOpen } from 'react-icons/hi';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { MdAddTask } from 'react-icons/md';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import {
  EXHIBITOR_USER_FAILED,
  AUTH_VISITOR_USER_FAILED,
  imgUrl,
  CONTACT_INFO,
} from '../../../Helpers/Constant';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import { IoPeopleCircle } from 'react-icons/io5';
import { FaPeopleArrows } from 'react-icons/fa';
import CommonContainer from '../../../Components/Common/CommonContainer';
import { GiDiscussion } from 'react-icons/gi';
import { VscGitPullRequestCreate } from 'react-icons/vsc';
const Profile = () => {
  const id = useParams();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();
  const { dispatch: VisitorAuthDispatch } = VisitorAuthContext();
  const location = useLocation();
  const handleLogout = () => {
    localStorage.removeItem('toab_fair');
    authDispatch?.({
      type: EXHIBITOR_USER_FAILED,
    });
    VisitorAuthDispatch?.({
      type: AUTH_VISITOR_USER_FAILED,
    });
  };

  return (
    <>
      <Layout pathName={'Exhibitor Profile'} showHeader>
        <div>
          <CommonContainer>
            <Row className='g-3'>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className='profile-left-side'>
                  <div className='profile-left-side-wrapper'>
                    <div>
                      <img
                        height={160}
                        style={{
                          objectFit: 'contain',
                          maxWidth: '300px',
                          border: '1px solid #ffacac',
                          borderRadius: '10px',
                          padding: '6px',
                        }}
                        width={'100%'}
                        src={`${imgUrl}/${exhibitorUser?.user_fair_member_company_logo}`}
                        alt=''
                      />
                    </div>
                    <div className='pt-2'>
                      <p className='fs-5'>
                        {exhibitorUser.user_fair_member_company_name}{' '}
                      </p>
                    </div>
                    <div className='pt-1'>
                      <p>{exhibitorUser.user_fair_member_email} </p>
                    </div>
                  </div>
                </div>

                <div className='profile-left-side mt-4 ps-4 py-3'>
                  <p className='font-italic fw-bold fs-4 mb-3'>Profile Menu</p>
                  <div>
                    <Link
                      to='/profile'
                      className={
                        location.pathname === '/profile'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pb-3'>
                        <CgProfile size={18} />
                        <p>Profile</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/register-visitors'
                      className={
                        location.pathname === '/profile/register-visitors'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pb-3'>
                        <IoPeopleCircle size={20} />
                        <p>Registered Staff</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/space-requirements'
                      className={
                        location.pathname === '/profile/space-requirements'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <BsFillSdCardFill />
                        <p>Book Stall</p>
                      </div>
                    </Link>

                    <Link
                      to='/profile/additional-service'
                      className={
                        location.pathname === `/profile/additional-service`
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 py-3'>
                        <MdAddTask />
                        <p>Additional Service</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/product-and-services'
                      className={
                        location.pathname === `/profile/product-and-services`
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <CgProductHunt />
                        <p>My Offering</p>
                      </div>
                    </Link>

                    <Link
                      to='/profile/meeting-create'
                      className={
                        location.pathname === '/profile/meeting-create'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pt-3'>
                        <VscGitPullRequestCreate size={20} />
                        <p>My Available Slots</p>
                      </div>
                    </Link>
                    <Link
                      to={`/profile/meeting-request?type=Exhibitor&user_id=${exhibitorUser?.user_fair_member_id}`}
                      className={
                        location.pathname === `/profile/meeting-request`
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pt-3'>
                        <GiDiscussion size={20} />
                        <p>Received Meeting Request</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/my-leads'
                      className={
                        location.pathname === '/profile/my-leads'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 py-3'>
                        <BiUserCheck />
                        <p>My Leads (Exhibition)</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/online-visitors'
                      className={
                        location.pathname === '/profile/online-visitors'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <FaPeopleArrows />
                        <p>Online Leads</p>
                      </div>
                    </Link>

                    {/* <Link
                      to='/profile/my-meeting-request'
                      className={
                        location.pathname === '/profile/my-meeting-request'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pt-3'>
                        <FaPeopleCarry size={20} />
                        <p>My Meeting Request</p>
                      </div>
                    </Link> */}

                    <Link
                      to='/profile/billing-info'
                      className={
                        location.pathname === '/profile/billing-info' ||
                        location.pathname ===
                          `/profile/view-billing-info/${id?.id}` ||
                        location.pathname === `/profile/payment-management`
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 pt-3'>
                        <FaFileInvoice />
                        <p>Billing Info</p>
                      </div>
                    </Link>
                    <Link
                      to='/profile/change-password'
                      className={
                        location.pathname === '/profile/change-password'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2 py-3'>
                        <RiKeyLine />
                        <p>Change Password</p>
                      </div>
                    </Link>

                    <div
                      className='d-flex align-items-center gap-2 pointer'
                      onClick={handleLogout}
                    >
                      <BiLogOutCircle />
                      <p>Logout</p>
                    </div>
                  </div>
                </div>

                <div className='profile-left-side mt-4 px-4 py-3 d-none d-md-block'>
                  <div className='text-center pb-3'>
                    <RiWechatLine size={100} />
                    <p className='fs-3 fw-800'>Need help?</p>
                  </div>
                  <div className='pt-2 ps-2 pb-4'>
                    <div>
                      <ImLocation />
                      <span className='ps-2'>{CONTACT_INFO.address}</span>
                    </div>
                    <div className='py-3'>
                      <HiOutlineMailOpen />
                      <span className='ps-2'>{CONTACT_INFO.email}</span>
                    </div>
                    <div className=''>
                      <HiPhone />
                      <span className='ps-2'>{CONTACT_INFO.phone}</span>
                    </div>
                  </div>

                  <Button
                    type='submit'
                    className='w-100 submit-button common-btn'
                  >
                    Contact us
                  </Button>
                </div>
              </Col>
              <Col xs={12} md={9} lg={9}>
                <div className='mt-5 mt-md-0'>
                  <Outlet />
                </div>
              </Col>
            </Row>
          </CommonContainer>
        </div>
      </Layout>
    </>
  );
};

export default Profile;
